import { acceptIdpDisclaimer } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { DosespotIDPRecordT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';
import { logger } from '@/shared';

/**
 * Accept the IDP disclaimer for the authenticated user.
 */
export async function fetchAcceptIdpDisclaimer(signal?: AbortSignal): Promise<DosespotIDPRecordT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await acceptIdpDisclaimer(config);
  const data = lotusHealthZod.acceptIdpDisclaimerResponse.parse(
    response.data
  ) as DosespotIDPRecordT;

  logger.info('dosespot.idp.acceptDisclaimer', {
    source: 'entities/dosespot-idp/api',
    currentState: data.current_state,
  });

  return data;
}
